var adSizes = require('./ad-sizes.js');

var specialCaseActions = {
    'carousel_translated':'translated.owl.carousel',
    'carousel_translate': 'translate.owl.carousel',
    'viewport':'viewport',
    'accordion_expand': 'shown.bs.collapse'
};

/**
 * Splits the expression in into <|> [=] alias
 */
function splitExpression( str ) {

    // Used operator
    var operator = str.charAt(0);
    // Include breakpoint equal to alias?
    var orEqual  = (str.charAt(1) == '=') ? true : false;

    /**
     * Index at which breakpoint name starts.
     *
     * For:  >sm, index = 1
     * For: >=sm, index = 2
     */
    var index = 1 + (orEqual ? 1 : 0);

    /**
     * The remaining part of the expression, after the operator, will be treated as the
     * breakpoint name to compare with
     */
    var value = str.slice(index);

    return {
        operator:       operator,
        orEqual:        orEqual,
        value:          parseInt(value)
    };
}

/**
 * Compares expression with innerWidth
 */
function isInRange(expr) {
    var expression = splitExpression(expr);
    var width = window.innerWidth;
    var pos = expression.value;
    var start = 0;
    var end   = 0;
    if( expression.operator == '<' ) {
        start = 0;
        end   = expression.orEqual ? ++pos : pos;
    }
    if( expression.operator == '>' ) {
        start = expression.orEqual ? --pos : pos;
        end   = Infinity;
    }
    return (start < width) && (width < end);
}

function breakpointCheck(responsiveToolkit){
    return function(attr) {
        // if no breakpoint is available it will render for all breakpoints.
        var result = true;
        if (attr) {
            var breakpoints = attr.split(',');
            for(var i = 0; i < breakpoints.length; i++) {
                if (breakpoints[i].match(/[0-9]+/)) {
                    result = result && isInRange(breakpoints[i]);
                } else {
                    result = result && responsiveToolkit.is(breakpoints[i]);
                }
            }
        }
        return result;
    };
}

/**
 * convertrs a string into a map of key value pairs.  the format of the string
 * is <key>=<value>;<key>=<value>;
 * Example:
 * "pos=1;adname=mrect;"
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */
function parseTargetingValues(str) {
    var toReturn = {};
    if (str && str.length) {
        var split = str.split(/=|; */);
        for (var i = 0; i < split.length; i = i + 2) {
            toReturn[split[i]] = split[i + 1];
        }
    }
    return toReturn;
}

function parseSize(adName) {
    return adSizes.getSize(adName);
}

function parseZones(str) {
    if(str){
        return str.split(/ *, */);
    }

    return [];
}

var checkViewEvent = function(el, event) {
    var slide;
    if (event.target.id === 'safety-insurance-estimator-accordion-collapse') {
        return true;
    }
    var carousel = $(event.target);
    if (event.type === 'translated') {
        slide = $(el).closest('.owl-item');
        return (slide.hasClass('active') && slide[0] && slide[0] == carousel.find('.owl-item')[event.item.index]);
    }
    slide = $(el).closest('.owl-item').not('.cloned');
    if(slide[0] && slide[0] == carousel.find('.owl-item')[event.item.index]){
        return true;
    }
};

var slideInView = function(el, event){
    var slide;
    if (!event) {
        slide = $(el).closest('.owl-item');
        return slide.hasClass('active');
    } else {
        return checkViewEvent(el, event);
    }
};

var isSpecialCaseActionDefer = function(action) {
    return (action === specialCaseActions.carousel_translated || action === specialCaseActions.carousel_translate
    || action === specialCaseActions.viewport) || action === specialCaseActions.accordion_expand;
};

var withinViewport = function(el, deferOnAction, e) {
    if(el) {
        if(isSpecialCaseActionDefer(deferOnAction)){
            return slideInView(el, e);
        }
        var rect = el[0].getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            );
    }
    return false;
};
module.exports = {
    breakpointCheck: breakpointCheck,
    parseTargetingValues:parseTargetingValues,
    parseSize: parseSize,
    parseZones: parseZones,
    withinViewport: withinViewport
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-tags/async-gpt-tag-utilities.js
// module id = 190
// module chunks = 36